<dx-button text="Request additional info" (onClick)="onRequestAdditioanlInfoClick($event)">
</dx-button>

<form-popup [(visible)]="isRequestAdditionalInfoPopupOpened" titleText="Additional info" buttonSavedText="Send request"
    (save)="onConfirmRequestAdditionalInfoClick($event)">
    <app-rich-form [colCount]="1" [cardData]="data" [formwidth]="350" [items]="formUiWidgets"
        (dataChanged)="dataChanged($event)">
    </app-rich-form>
</form-popup>